var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.65466,
    y: 15.5,
    width: 27.1464,
    height: 26.1409,
    transform: "rotate(-15 7.65466 15.5)",
    fill: "#FEE39A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_685_7100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1524 24.2035L17.9661 25.8611L19.6237 32.0473L25.81 30.3897L24.1524 24.2035Z",
    fill: "#FEE39A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67189 15.9195L8.275 14.4382L6.79379 14.8351L7.19068 16.3163L8.67189 15.9195ZM33.4324 9.28491L34.9136 8.88802L34.5167 7.40681L33.0355 7.8037L33.4324 9.28491ZM39.8556 33.2566L40.2524 34.7378L41.7336 34.3409L41.3368 32.8597L39.8556 33.2566ZM15.0951 39.8912L13.6139 40.288L14.0108 41.7693L15.492 41.3724L15.0951 39.8912ZM15.7342 11.5447C15.517 10.7261 14.6774 10.2385 13.8588 10.4557C13.0402 10.6728 12.5527 11.5125 12.7698 12.3311L15.7342 11.5447ZM21.9349 9.87923C21.7157 9.06118 20.8749 8.57571 20.0568 8.79491C19.2388 9.01411 18.7533 9.85496 18.9725 10.673L21.9349 9.87923ZM28.0735 8.22913C27.8515 7.41181 27.0091 6.92915 26.1918 7.15107C25.3744 7.37299 24.8918 8.21546 25.1137 9.03277L28.0735 8.22913ZM24.1524 24.2035L25.6336 23.8066L25.2367 22.3254L23.7555 22.7223L24.1524 24.2035ZM17.9661 25.8611L17.5693 24.3799L16.088 24.7767L16.4849 26.258L17.9661 25.8611ZM19.6237 32.0473L18.1425 32.4442L18.5394 33.9254L20.0206 33.5285L19.6237 32.0473ZM25.81 30.3897L26.2069 31.8709L27.6881 31.474L27.2912 29.9928L25.81 30.3897ZM9.06878 17.4007L33.8292 10.7661L33.0355 7.8037L8.275 14.4382L9.06878 17.4007ZM31.9511 9.6818L38.3743 33.6535L41.3368 32.8597L34.9136 8.88802L31.9511 9.6818ZM39.4587 31.7754L14.6982 38.41L15.492 41.3724L40.2524 34.7378L39.4587 31.7754ZM16.5763 39.4943L10.1531 15.5226L7.19068 16.3163L13.6139 40.288L16.5763 39.4943ZM17.3763 17.7351L15.7342 11.5447L12.7698 12.3311L14.4119 18.5214L17.3763 17.7351ZM23.5925 16.0655L21.9349 9.87923L18.9725 10.673L20.6301 16.8593L23.5925 16.0655ZM29.7517 14.4098L28.0735 8.22913L25.1137 9.03277L26.7919 15.2135L29.7517 14.4098ZM23.7555 22.7223L17.5693 24.3799L18.363 27.3423L24.5493 25.6847L23.7555 22.7223ZM16.4849 26.258L18.1425 32.4442L21.105 31.6504L19.4474 25.4642L16.4849 26.258ZM20.0206 33.5285L26.2069 31.8709L25.4131 28.9085L19.2269 30.5661L20.0206 33.5285ZM27.2912 29.9928L25.6336 23.8066L22.6712 24.6004L24.3288 30.7866L27.2912 29.9928Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_685_7100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4268,
    height: 38.4268,
    fill: "white",
    transform: "translate(0.62085 10.6191) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.de57118cf0f41ed52d96aa4db307026c.svg";
export { ForwardRef as ReactComponent };